/** 
 * SECTION API Productions types
 */

export enum ProductionStatusesEnum {
  NEW = 'NEW',
  BEWERKEN = 'BEWERKEN',
  PROCESSED = 'PROCESSED'
}

interface IproductionInstance {
    id: number;
    description: string | null;
    file: any;
    notes: string | null;
    reference: string;
    transporter: { [k: string]: any };
    deliverAt: Date | null;
    changedAt: Date | null;
    createdAt: Date;
    order: number;
}

export interface IProductionRecord {
  id: number;
  quantity: string;
  worktype: string;
  description: string;
  notes: string;
  changedAt: null;
  createdAt: Date;
  production: number | IproductionInstance;
  orderLine: IOrderLineExtended;
  status?: string | null;
}

export interface IproductionCutInstance {
  id: number;
  quantity: string,
  worktype: string
  description: string | null;
  status: ProductionStatusesEnum
  notes: string | null;
  reference: string;
  transporter: { [k: string]: any };
  deliverAt: Date | null;
  changedAt: Date | null;
  createdAt: Date;
  order: number;
  orderLine: number,
  production: number | IproductionInstance;
  business: string,
  sku : string,
  name: string,
  items: number,
  sheets: number,
  surface: number
}


export interface IWorktype {
  [key: string]: {label: string, default: boolean};
}

export interface IOrderLineExtended {
  id: number;
  description: string;
  notes: null | string;
  quantity: string;
  weight: null;
  length: null | string;
  width: null | string;
  price: string;
  tax: number;
  discount: null;
  total: string;
  status: string;
  statusDescription: null;
  changedAt: Date | null;
  createdAt: Date;
  order: number;
  ledgerCode: null;
  product: IProductExtended;
  fulfilmentline: null;
  SKU: string;
}

export interface IProductExtended {
  id: number;
  sku: string;
  ean: null | string;
  unit: null;
  quantity: number;
  weight: null;
  purchasePrice: null | string;
  currency: string;
  price: string;
  isSystem: boolean;
  name: null | string;
  notes: null;
  sortOrder: null;
  isActive: number;
  isDeleted: number;
  isStock: number;
  createdAt: Date;
  changedAt: null | string;
  catalog: number;
  productType: number;
  tax: number;
  stock: null;
  defaultWarehouse: number | null;
  mainSupplier: null;
  relatedProduct?: any[];
  productRelatedTo?: any[];
  offer?: null;
}